import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CompanyModel } from "../model/company.model";
import { GlobalSettings } from "../model/settings.model";
import { AuthenticationService } from "./auth.service";
import { ResourceService } from "./resource.service";

@Injectable({
    providedIn: 'root'
})
export class CompanyService extends ResourceService<CompanyModel> {

    constructor(
        http: HttpClient,
        settings: GlobalSettings,
        authenticationService: AuthenticationService) {
        super(http, "gateway/Public/Companies", settings.processosUrl, authenticationService)
    }
}
